import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import Tooltip from 'components/common/Tooltip';
import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import IconMoreVert from 'components/icons/IconMoreVert';
import PayerCreateEditDialog from 'components/settings/PayerCreateEditDialog';
import Link from 'components/common/Link';

import splitLongWords from 'utils/splitLongWords';

const styles = theme => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  cellPayerName: {
    width: '32%',
  },
  cellServices: {
    whiteSpace: 'nowrap',
  },
  tooltipService: {
    '& + $tooltipService': {
      marginLeft: 4,
    },
  },
  typographyService: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    color: theme.palette.common.white,
    cursor: 'pointer',
    backgroundColor: theme.palette.primary[500],
    '& + $typographyService': {
      marginLeft: 4,
    },
  },
  typographyServiceEnrollment: {
    backgroundColor: theme.palette.grey[600],
  },
});

class PayersTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      editDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { account, systemSettings, classes } = this.props;
    const { anchorEl, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);
    const phoneContacts = this.props.Contacts
      ? this.props.Contacts
      .filter(item => item.type === 'Phone')
      .map(item => ({
        Value: item.value,
        Description: item.description,
      })) : [];
    const faxContacts = this.props.Contacts
      ? this.props.Contacts
      .filter(item => item.type === 'Fax')
      .map(item => ({
          Value: item.value,
          Description: item.description,
        })) : [];
    const emailContacts = this.props.Contacts
      ? this.props.Contacts
      .filter(item => item.type === 'Email')
      .map(item => ({
          Value: item.value,
          Description: item.description,
        })) : [];
    return (
      <TableRow>
        <TableCell className={classes.cellPayerName}>
          <Link
            breakWord
            onClick={this.onEditMenuItemClick}
            disabled={account.Roles.filter(item =>
              item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
          >
            {splitLongWords(this.props['Payer Name'], 100)}
          </Link>
        </TableCell>
        <TableCell>
          {this.props['Profit Percent Medicare'] !== null && 
            <Fragment>
              {Math.sign(this.props['Profit Percent Medicare']) === 1 && '+'}
              {`${this.props['Profit Percent Medicare']}% MCR`}
            </Fragment>
          }
          {this.props['Profit Percent Medicaid'] !== null && 
            <Fragment>
              {Math.sign(this.props['Profit Percent Medicaid']) === 1 && '+'}
              {`${this.props['Profit Percent Medicaid']}% MCD`}
            </Fragment>
          }
          {(this.props['Profit Percent Medicaid'] === null && this.props['Profit Percent Medicare'] === null
            && systemSettings['System Config'] && systemSettings['System Config'].PROFIT_PERCENT !== undefined) &&
            <Fragment>
              {Math.sign(systemSettings['System Config'].PROFIT_PERCENT) === 1 && '+'}
              {`${systemSettings['System Config'].PROFIT_PERCENT}%`}
            </Fragment>
          }
        </TableCell>
        <TableCell>
          {(this.props['Default Claim Filling Code'] && this.props['Default Claim Filling Code'].ID)
            && splitLongWords(this.props['Default Claim Filling Code']['Full Name'])}
        </TableCell>
        <TableCell>
          {this.props['Default Order Benefits']}
        </TableCell>
        <TableCell>
          {this.props['Default Transmission Method']}
        </TableCell>
        <TableCell>
          {(this.props['Claim Md Payer'] && this.props['Claim Md Payer'].ID)
            && this.props['Claim Md Payer']['Payer Name']}
        </TableCell>
        <TableCell>
          {this.props['Claim Md Payer']['Payer ID']}
        </TableCell>
        <TableCell className={classes.cellServices}>
          {(this.props['Claim Md Payer'] && this.props['Claim Md Payer'].ID)
            && <Fragment>
              {this.props['Claim Md Payer']['Claims 1500'] && (
                <Tooltip
                  className={classes.tooltipService}
                  content={
                    <Typography>
                      Claims
                      {this.props['Claim Md Payer']['Claims 1500'] === 'enrollment' &&
                        '(Enrollment)'
                      }
                    </Typography>
                  }
                  placement="top"
                >
                  <Typography
                    className={classNames(classes.typographyService, {
                      [classes.typographyServiceEnrollment]: this.props['Claim Md Payer']['Claims 1500'] === 'enrollment',
                    })}
                    variant="caption"
                  >
                    C
                  </Typography>
                </Tooltip>
              )}
              {this.props['Claim Md Payer']['Eligibility'] && (
                <Tooltip
                  className={classes.tooltipService}
                  content={
                    <Typography>
                      Eligibility
                    </Typography>
                  }
                  placement="top"
                >
                  <Typography
                    className={classes.typographyService}
                    variant="caption"
                  >
                    E
                  </Typography>
                </Tooltip>
              )}
              {this.props['Claim Md Payer'].Era && (
                <Tooltip
                  className={classes.tooltipService}
                  content={
                    <Typography>
                      Remittance
                      {this.props['Claim Md Payer'].Era === 'enrollment' &&
                        '(Enrollment)'
                      }
                    </Typography>
                  }
                  placement="top"
                >
                  <Typography
                    className={classNames(classes.typographyService, {
                      [classes.typographyServiceEnrollment]: this.props['Claim Md Payer'].Era === 'enrollment',
                    })}
                    variant="caption"
                  >
                    R
                  </Typography>
                </Tooltip>
              )}
              {this.props['Claim Md Payer']['Attachment'] && (
                <Tooltip
                  className={classes.tooltipService}
                  content={
                    <Typography>
                      Attachment
                    </Typography>
                  }
                  placement="top"
                >
                  <Typography
                    className={classes.typographyService}
                    variant="caption"
                  >
                    A
                  </Typography>
                </Tooltip>
              )}
              {this.props['Claim Md Payer']['Secondary Support'] && (
                <Tooltip
                  className={classes.tooltipService}
                  content={
                    <Typography>
                      Secondary Payer Support
                      {this.props['Claim Md Payer']['Secondary Support'] === 'enrollment' &&
                        '(Enrollment)'
                      }
                    </Typography>
                  }
                  placement="top"
                >
                  <Typography
                    className={classNames(classes.typographyService, {
                      [classes.typographyServiceEnrollment]: this.props['Claim Md Payer']['Secondary Support'] === 'enrollment',
                    })}
                    variant="caption"
                  >
                    S
                  </Typography>
                </Tooltip>
              )}
            </Fragment>}
        </TableCell>
        <TableCell>
          {this.props['Is Active'] ? 'Active' : 'Inactive'}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-payer-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-payer-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list
            maxHeight={130}
          >
            <MenuItem
              onClick={this.onEditMenuItemClick}
              disabled={account.Roles.filter(item =>
                item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
            >
              Edit
            </MenuItem>
          </Menu>
        </TableCell>
        <PayerCreateEditDialog
          form={`payerEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            'Payer Name': this.props['Payer Name'],
            'Patient Map Payer Name': this.props['Patient Map Payer Name'] || '',
            'Is Active': this.props['Is Active'],
            ...(this.props['Default Claim Filling Code'] && this.props['Default Claim Filling Code'].ID) ? {
              'Default Claim Filling Code Name': this.props['Default Claim Filling Code']['Full Name'],
              'Selected Default Claim Filling Code Name': this.props['Default Claim Filling Code']['Full Name'],
              'Default Claim Filling Code ID': this.props['Default Claim Filling Code'].ID,
            } : {},
            'Default Order Benefits': this.props['Default Order Benefits'],
            'Default Transmission Method': this.props['Default Transmission Method'],
            ...(this.props['Change Info'] && this.props['Change Info'].ID) ? {
              'Change Info Trading Partner Name': this.props['Change Info']['Trading Partner Name'],
              'Selected Change Info Trading Partner Name': this.props['Change Info']['Trading Partner Name'],
              CPID: this.props['Change Info']['Trading Partner Code'],
              'Selected CPID': this.props['Change Info']['Trading Partner Code'],
              'Change Info ID': this.props['Change Info'].ID,
            } : {},
            ...(this.props['Claim Md Payer'] && this.props['Claim Md Payer'].ID) ? {
              'Claim MD Payer Name': this.props['Claim Md Payer']['Payer Name'],
              'Selected Claim MD Payer Name': this.props['Claim Md Payer']['Payer Name'],
              'Payer ID': this.props['Claim Md Payer']['Payer ID'],
              'Selected Payer ID': this.props['Claim Md Payer']['Payer ID'],
              'Claim MD ID': this.props['Claim Md Payer'].ID,
              Services: [
                ...this.props['Claim Md Payer']['Claims 1500'] ? ['Claims'] : [],
                ...this.props['Claim Md Payer']['Eligibility'] ? ['Eligibility'] : [],
                ...this.props['Claim Md Payer'].Era ? ['Remittance'] : [],
                ...this.props['Claim Md Payer']['Attachment'] ? ['Attachment'] : [],
                ...this.props['Claim Md Payer']['Secondary Support'] ? ['Secondary Support'] : [],
              ],
            } : {},
            ...this.props['Profit Percent Medicaid'] === null
              && this.props['Profit Percent Medicare'] === null ? {
                'Profit Percent Type': 'Default',
                ...systemSettings['System Config'] && systemSettings['System Config'].PROFIT_PERCENT !== undefined ? {
                  'Profit Percent': `${systemSettings['System Config'].PROFIT_PERCENT}%`,
                } : {},
              } : {},
            ...this.props['Profit Percent Medicaid'] !== null ? {
              'Profit Percent Type': 'Medicaid',
              'Profit Percent': `${this.props['Profit Percent Medicaid']}%`,
            } : {},
            ...this.props['Profit Percent Medicare'] !== null ? {
              'Profit Percent Type': 'Medicare',
              'Profit Percent': `${this.props['Profit Percent Medicare']}%`,
            } : {},
            Street: this.props.Street,
            Suite: this.props.Apt,
            City: this.props.City,
            State: this.props.State,
            'Zip Code': this.props['Zip Code'],
            'Contacts Phone': phoneContacts.length > 0 ? phoneContacts : [
              {
                Value: '',
                Description: '',
              }
            ],
            'Contacts Fax': faxContacts.length > 0 ? faxContacts : [
              {
                Value: '',
                Description: '',
              }
            ],
            'Contacts Email': emailContacts.length > 0 ? emailContacts : [
              {
                Value: '',
                Description: '',
              }
            ],
          }}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

PayersTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  'Payer Name': PropTypes.string.isRequired,
  'Patient Map Payer Name': PropTypes.string,
  'Is Active': PropTypes.bool.isRequired,
  'Default Order Benefits': PropTypes.string,
  'Default Transmission Method': PropTypes.string,
  'Default Claim Filling Code': PropTypes.shape({
    ID: PropTypes.number,
    'Full Name': PropTypes.string,
  }),
  'Change Info': PropTypes.shape({
    ID: PropTypes.number,
    'Trading Partner Name': PropTypes.string,
    Services: PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
    })),
  }),
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  'Profit Percent Medicaid': PropTypes.number,
  'Profit Percent Medicare': PropTypes.number,
  Street: PropTypes.string,
  Suite: PropTypes.string,
  City: PropTypes.string,
  State: PropTypes.string,
  'Zip Code': PropTypes.string,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    cellPayerName: PropTypes.string.isRequired,
    tooltipService: PropTypes.string.isRequired,
    typographyService: PropTypes.string.isRequired,
  }).isRequired,
};

PayersTableRow.defaultProps = {
  'Patient Map Payer Name': null,
  'Default Claim Filling Code': null,
  'Default Order Benefits': null,
  'Default Transmission Method': null,
  'Change Info': null,
  'Profit Percent Medicaid': null,
  'Profit Percent Medicare': null,
  Street: null,
  Suite: null,
  City: null,
  State: null,
  'Zip Code': null,
};

const mapStateToProps = store => ({
  account: store.account,
  systemSettings: store.systemSettings.data,
});

export default connect(mapStateToProps)(withStyles(styles)(PayersTableRow));



// WEBPACK FOOTER //
// ./src/components/settings/PayersTable/PayersTableRow.js